import { Injectable } from '@angular/core';
import {INewRelicData} from './interfaces/new-relic-data.interface';

declare global {
  interface Window {
    newrelic: any;
    NREUM: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class NewRelicService {

  constructor() {
    this.waitForNewRelic();
  }

  private waitForNewRelic(): void {
    // Esperar a que New Relic se inicialice
    const checkNewRelic = () => {
      if (typeof window !== 'undefined' && window.newrelic) {
        console.log('✅ New Relic initialized successfully');
        this.setInitialAttributes();
      } else {
        setTimeout(checkNewRelic, 100);
      }
    };
    checkNewRelic();
  }
  private setInitialAttributes(): void {
    // Establecer atributos iniciales
    this.addCustomAttribute('framework', 'Angular');
    this.addCustomAttribute('timestamp', new Date().toISOString());
  }

  /**
   * Clean object of new relic data service
   */
  cleanObject = <T>(value: object) =>
    Object.entries(value).reduce(
      (
        acc: {
          [key: string]: string;
        },
        [key, value]
      ) => {
        if (value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      },
      {}
    ) as unknown as T;
  /**
   * Details of new relic data service
   */
  parseDetails = (details?: INewRelicData): INewRelicData => {
    return this.cleanObject<INewRelicData>(
      Object.assign(
        {
          origin,
          application: 'SFI-ROHAN',
          applicationId: 'rohan-avi-payments',
          stepUrl: window.location.href,
        },
        details
      )
    );
  };
  private isNewRelicAvailable(): boolean {
    return typeof window !== 'undefined' &&
      window.newrelic &&
      typeof window.newrelic === 'object';
  }
  // Inicializar New Relic
  init(config: any) {
    if (typeof window !== 'undefined' && window.newrelic) {
      window.newrelic.setCustomAttribute('appVersion', config.appVersion);
      window.newrelic.setCustomAttribute('environment', config.environment);
    }
  }

  // Registrar errores personalizados
  noticeError(error: Error, customAttributes?: any) {
    if (this.isNewRelicAvailable()) {
      console.log('🔴 Sending error to New Relic:', error.message);
      window.newrelic.noticeError(error, customAttributes);
    } else {
      console.warn('⚠️ New Relic not available for error reporting');
    }
  }

  // Agregar atributos personalizados
  addCustomAttribute(key: string, value: any): void {
    if (this.isNewRelicAvailable()) {
      window.newrelic.setCustomAttribute(key, value);
    }
  }

  // Rastrear eventos personalizados
  addPageAction(actionName: string, attributes?: any): void {
    if (this.isNewRelicAvailable()) {
      console.log('📊 New Relic PageAction:', actionName, attributes);
      window.newrelic.addPageAction(actionName, attributes);
    }
  }

  // Establecer ID de usuario
  setUserId(userId: string): void {
    if (this.isNewRelicAvailable()) {
      console.log('👤 Setting New Relic User ID:', userId);
      window.newrelic.setUserId(userId);
    }
  }

  getStatus(): { available: boolean, info?: any } {
    if (this.isNewRelicAvailable()) {
      return {
        available: true,
        info: {
          version: window.NREUM?.info || 'Unknown',
          hasNewRelic: !!window.newrelic
        }
      };
    }
    return { available: false };
  }
}
